import React from "react";
import { useTranslation } from "react-i18next";
import { UserIcon, EditIcon } from "../assets/constants/Icons";
import CustomDialog from "./CustomDialog";
import { CustomTextInput } from "./CustomTextInput";
import { BUTTON_PRIMARY, BUTTON_WARNING } from "../assets/constants/Constants";
import CustomMobileInput from "./CustomMobileInput";

export default function UserDetailsComponent({ userInfo }) {
  const { t } = useTranslation();

  const [isEditOpen, setIsEditOpen] = React.useState(false);

  const [formData, setFormData] = React.useState({
    name: userInfo?.username || "",
    email: userInfo?.email || "",
    mobile: userInfo?.mobile_number || ""
  });

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSave = () => {
    console.log("Updated:", formData);
    setIsEditOpen(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-IN", {
      month: "short",
      year: "numeric"
    });
  };


//   const renderEditForm = () => (
//   <div className="form-container">
//     <CustomTextInput
//       text=" Enter your Name"
//       value={formData.name}
//       onChange={handleChange("name")}
//     />

//     <CustomTextInput
//       text=" Enter your Email"
//       type="email"
//       value={formData.email}
//       onChange={handleChange("email")}
//     />

//     <CustomTextInput
//       text=" Enter your Mobile"
//       type="tel"
//       value={formData.mobile}
//       onChange={handleChange("mobile")}
//     />
//   </div>
// );
const renderEditForm = () => (
  <div className="form-container">

    {/* ✅ Name */}
    <div className="inputContainer">
      <CustomTextInput
        text="Name"
        value={formData.name}
        onChange={handleChange("name")}
      />
    </div>

    {/* ✅ Email */}
    <div className="inputContainer">
      <CustomTextInput
        className="emailInput"
        type="email"
        text="Email"
        value={formData.email}
        onChange={handleChange("email")}
      />
    </div>

    {/* ✅ Mobile */}
    <div className="inputContainer">
      <CustomMobileInput
        value={formData.mobile}
        handleSetMobile={(value) =>
          setFormData({ ...formData, mobile: value })
        }
      />
    </div>

  </div>
);

  return (
    <>
      <div className="user-card">
       <div className="user-card__top">
  <UserIcon />

  <div className="user-info">
    {/* 🔹 New wrapper */}
    <div className="name-row">
      <h3>{userInfo?.username}</h3>

      <div
        className="edit-icon"
        onClick={() => setIsEditOpen(true)}
      >
        <EditIcon />
      </div>
    </div>

    <p>{userInfo?.email}</p>
  </div>
</div>

        <hr />

        <div className="user-card__bottom">
          <div className="info-row">
            <span className="label">{t("phone_label")}</span>
            <span className="value">{userInfo?.mobile_number}</span>
          </div>

          <div className="info-row">
            <span className="label">{t("member_since_label")}</span>
            <span className="value">
              {formatDate(userInfo?.date_joined)}
            </span>
          </div>
        </div>
      </div>

      {/* ✅ Edit Modal */}
      <CustomDialog
          dialogVisible={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          handleCancel={() => setIsEditOpen(false)}
          handleAccept={handleSave}
          dialogTitle="Edit Profile"
          buttonOneTitle="Cancel"
          buttonTwoTitle="Save"
          buttonProps={{ buttonOne: {type: BUTTON_WARNING}, buttonTwo: {type: BUTTON_PRIMARY}}}
          // children={renderEditForm()}
        >
           {() => renderEditForm()}
          </CustomDialog>
       
    </>
  );
}